import React from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';

import MenuBlock from 'components/atoms/MenuBlock';
import LanguageButton from 'components/atoms/LanguageButton';
import SocialMedia from 'components/atoms/SocialMedia';
import styles from './index.css';

const fisrtItem = (t, onOpenLoginSignupModal) => [
	{
		id: 0,
		name: t('login'),
		type: 'action',
		onClick: () => {
			onOpenLoginSignupModal('loginForm');
		},
	},
];

const authItem = (t, routeName, onLogout) => [
	{ id: 0, name: t('navigator:overview'), url: `/${routeName}/user/overview`, type: 'internal' },
	{ id: 1, name: t('navigator:setting'), url: `/${routeName}/user/settings`, type: 'internal' },
	{ id: 2, name: t('navigator:favorites'), url: `/${routeName}/user/wishlist`, type: 'internal' },
	{
		id: 3,
		name: t('navigator:propertyHistory'),
		url: `/${routeName}/user/reservation`,
		type: 'internal',
	},
	{
		id: 4,
		name: t('navigator:reservationHistory'),
		url: `/${routeName}/user/booking`,
		type: 'internal',
	},
	{
		id: 5,
		name: t('navigator:onlineCommunity'),
		url: `/${routeName}/user/community`,
		type: 'internal',
	},
	{ id: 6, name: t('navigator:logout'), type: 'action', onClick: onLogout },
];

const secondItem = (t, routeName) => [
	{ id: 0, name: t('filter'), url: `/${routeName}/room`, type: 'internal' },
	{ id: 1, name: t('area'), url: `/${routeName}/map`, type: 'internal' },
	{ id: 2, name: t('pauian'), url: 'https://pure.9floor.co/', type: 'external' },
];

const thirdItem = (t, routeName) => [
	{ id: 0, name: t('about'), url: `/${routeName}/about`, type: 'internal' },
	{ id: 1, name: t('media'), url: `/${routeName}/media`, type: 'internal' },
	{ id: 2, name: t('team'), url: `/${routeName}/team`, type: 'internal' },
	{ id: 3, name: t('contact'), url: `/${routeName}/contact`, type: 'internal' },
];

const fourthItem = (t, routeName) => [
	{ id: 0, name: t('space'), url: `/${routeName}/space`, type: 'internal' },
	{ id: 1, name: t('coliving'), url: `/${routeName}/coliving`, type: 'internal' },
];

const fifthItem = () => [];

const sixthItem = (t, routeName) => [
	{ id: 0, name: t('how'), url: `/${routeName}/service`, type: 'internal' },
	{ id: 1, name: t('FAQ'), url: 'https://medium.com/9floor-co-living', type: 'external' },
	{ id: 2, name: t('contactUs'), url: `/${routeName}/contact`, type: 'internal' },
];

const seventhItem = (t, routeName) => [
	{ id: 0, name: t('termsofService'), url: `/${routeName}/terms`, type: 'internal' },
	{ id: 1, name: t('privacy'), url: `/${routeName}/privacy`, type: 'internal' },
	{ id: 2, name: t('sitemap'), url: `/${routeName}/sitemap`, type: 'internal' },
];

const MobileMenu = ({
	open,
	routeName = 'zh-tw',
	onOpenLoginSignupModal,
	closeMenu,
	isLogin,
	t,
	onLogout,
}) => (
	<div className={classnames(styles.mobileMenu, open ? styles.open : '')}>
		<div className={styles.blocks}>
			<MenuBlock
				title={t('member')}
				list={isLogin ? authItem(t, routeName, onLogout) : fisrtItem(t, onOpenLoginSignupModal)}
				closeMenu={closeMenu}
			/>
			<MenuBlock title={t('checkin')} list={secondItem(t, routeName)} closeMenu={closeMenu} />
			<MenuBlock title={t('ninthfloor')} list={thirdItem(t, routeName)} closeMenu={closeMenu} />
			<MenuBlock title={t('service')} list={fourthItem(t, routeName)} closeMenu={closeMenu} />
			<MenuBlock
				title={t('journal')}
				list={fifthItem()}
				closeMenu={closeMenu}
				titleLink="https://medium.com/9floor-co-living"
			/>
			<MenuBlock title={t('help')} list={sixthItem(t, routeName)} closeMenu={closeMenu} />
			<MenuBlock title="" list={seventhItem(t, routeName)} closeMenu={closeMenu} />
		</div>
		<div className={styles.bottom}>
			<SocialMedia />
			<LanguageButton />
		</div>
	</div>
);

export default translate('sitemap')(MobileMenu);



// WEBPACK FOOTER //
// ./src/components/molecules/MobileMenu/index.js